<template>
  <div data-test-id="emh-ui-checkbox">
    <ui-checkbox
      :selected="availabilityFilter.selected"
      :disabled="disabled"
      :label="$t('dcp.sideFiltersCategories.availability')"
      :value="availabilityFilter?.filterValue[0]"
      @change="onToggleStockTypeFilter()"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, toRefs } from 'vue';
import UiCheckbox from '@dh-io-emh/ui/src/form/checkbox/Checkbox.vue';
import { IProductFilterGroup } from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';

export default defineComponent({
  name: 'EmhSideFiltersAvailabilityCategory',
  components: {
    UiCheckbox,
  },

  props: {
    availabilityFilterCategory: {
      type: Object as PropType<IProductFilterGroup>,
      default: () => undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['change-filter'],

  setup(props, { emit }) {
    const { availabilityFilterCategory } = toRefs(props);

    const availabilityFilter = computed(() => {
      const filterValues = availabilityFilterCategory.value?.filters[0]?.values || [];

      const filterValue = filterValues.filter((value) => value.selected).map((value) => value.code);

      const myObject = {
        filterValue,
        selected: filterValue.length > 0,
      };

      return myObject;
    });

    const onToggleStockTypeFilter = () => {
      const availabilityFilterMap = {
        filterCode: availabilityFilterCategory.value?.code,
        filterValue: [availabilityFilterCategory.value?.filters[0].values[1].code],
        filterType: 'multiSelect',
        filterCurrentlySelectedItemValue: availabilityFilterCategory.value?.filters[0].value[0],
        selected: availabilityFilterCategory.value?.filters[0].values[1].selected,
      };

      availabilityFilterMap.selected = !availabilityFilterMap.selected;

      if (!availabilityFilterMap.selected) availabilityFilterMap.filterValue = [];

      emit('change-filter', availabilityFilterMap);
    };

    return {
      availabilityFilter,
      onToggleStockTypeFilter,
    };
  },
});
</script>

<style lang="scss" scoped>
.emh-ui-checkbox {
  @include wb-spacing('margin-top', 'xs');
  @include wb-spacing('margin-bottom', 's');
}
</style>
